const state = {
  cardNo: '',
  historyList: [],
  voucherList: [],
  mobile: '',
  backamt: '',
  cleanInfo: {},
  cardInfo: {
    cardNo: '',
    bankName: '',
    bankNo: '',
    bankAcctName: '',
    bankAccount: ''
  }, // 电子卡清户/退款表单字段
  cardInfoE: {
    cardNo: '',
    identifyType: '01',
    identifyNo: '',
    payType: '2',
    bankNo: '',
    bankName: '',
    bankAcctName: '',
    bankAccount: ''
  } //实体卡清户字段
}

const mutations = {
  SET_CARDNO(state, obj) {
    state.cardNo = obj.cardNo
  },
  SET_HISTORYLIST(state, data) {
    state.historyList = data.historyList
  },
  SET_VOUCHERLIST(state, data) {
    state.voucherList = data.voucherList
  },
  SET_INVOICElIST(state, data) {
    state.invoiceList = data.invoiceList
    state.backive = data.backive
  },
  SET_MOBILE(state, data) {
    state.mobile = data.mobile
  },
  SET_CLEAN(state, data) {
    state.cleanInfo = data.cleanInfo
  },
  CLEAN_FORM(state) {
    state.cardInfo.cardNo = ''
    state.cardInfo.bankName = ''
    state.cardInfo.bankNo = ''
    state.cardInfo.bankAcctName = ''
    state.cardInfo.bankAccount = ''
  },
  CLEAN_EFORM(state) {
    state.cardInfoE.cardNo = ''
    state.cardInfoE.identifyType = '01'
    state.cardInfoE.identifyNo = ''
    state.cardInfoE.payType = '2'
    state.cardInfoE.bankNo = ''
    state.cardInfoE.bankName = ''
    state.cardInfoE.bankAcctName = ''
    state.cardInfoE.bankAccount = ''
  },
  SET_BACKAMT(state, data) {
    state.backamt = data.backamt
  },
  INIT_DATA(state) {
    state.cardNo = ''
    state.historyList = []
    state.voucherList = []
    state.mobile = ''
    state.backamt = ''
    state.cleanInfo = {}
    state.cardInfo.cardNo = ''
    state.cardInfo.bankName = ''
    state.cardInfo.bankNo = ''
    state.cardInfo.bankAcctName = ''
    state.cardInfo.bankAccount = ''
    
    state.cardInfoE.cardNo = ''
    state.cardInfoE.identifyType = '01'
    state.cardInfoE.identifyNo = ''
    state.cardInfoE.payType = '2'
    state.cardInfoE.bankNo = ''
    state.cardInfoE.bankName = ''
    state.cardInfoE.bankAcctName = ''
    state.cardInfoE.bankAccount = ''
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
